module.exports = __webpack_public_path__ + "img/main_bg.ebd58b89.jpg";